export default __webpack_public_path__ + "static/media/circle-icon1.889b209b.png";